// src/i18n/locales/sw.js

export default {
  countries: {
    'AF': 'Afghanistani',
    'AL': 'Albania',
    'DZ': 'Aljeria',
    'AD': 'Andora',
    'AO': 'Angola',
    'AG': 'Antigua na Barbuda',
    'AR': 'Ajentina',
    'AM': 'Armenia',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijani',
    'BS': 'Bahamas',
    'BH': 'Bahareni',
    'BD': 'Bangladeshi',
    'BB': 'Barbados',
    'BY': 'Belarusi',
    'BE': 'Ubelgiji',
    'BZ': 'Belize',
    'BJ': 'Benini',
    'BT': 'Bhutani',
    'BO': 'Bolivia',
    'BA': 'Bosnia na Herzegovina',
    'BW': 'Botswana',
    'BR': 'Brazili',
    'BN': 'Brunei',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Cape Verde',
    'KH': 'Kambodia',
    'CM': 'Kameruni',
    'CA': 'Kanada',
    'CF': 'Jamhuri ya Afrika ya Kati',
    'TD': 'Chadi',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Kolombia',
    'KM': 'Komoro',
    'CG': 'Kongo',
    'CD': 'Jamhuri ya Kidemokrasia ya Kongo',
    'CR': 'Kosta Rika',
    'CI': 'Kodivaa',
    'HR': 'Kroeshia',
    'CU': 'Kuba',
    'CY': 'Kupro',
    'CZ': 'Jamhuri ya Cheki',
    'DK': 'Denmaki',
    'DJ': 'Jibuti',
    'DM': 'Dominika',
    'DO': 'Jamhuri ya Dominika',
    'EC': 'Ekwado',
    'EG': 'Misri',
    'SV': 'El Salvador',
    'GQ': 'Guinea ya Ikweta',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FJ': 'Fiji',
    'FI': 'Ufini',
    'FR': 'Ufaransa',
    'GA': 'Gaboni',
    'GM': 'Gambia',
    'GE': 'Jojia',
    'DE': 'Ujerumani',
    'GH': 'Ghana',
    'GR': 'Ugiriki',
    'GD': 'Grenada',
    'GT': 'Guatemala',
    'GN': 'Gine',
    'GW': 'Gine-Bisau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HN': 'Hondurasi',
    'HU': 'Hungaria',
    'IS': 'Aisilandi',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Irani',
    'IQ': 'Iraki',
    'IE': 'Ayalandi',
    'IL': 'Israeli',
    'IT': 'Italia',
    'JM': 'Jamaika',
    'JP': 'Japani',
    'JO': 'Yordani',
    'KZ': 'Kazakistani',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'Korea Kaskazini',
    'KR': 'Korea Kusini',
    'KW': 'Kuwaiti',
    'KG': 'Kirigizistani',
    'LA': 'Laosi',
    'LV': 'Latvia',
    'LB': 'Lebanoni',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtensteini',
    'LT': 'Lithuania',
    'LU': 'Luxemburgi',
    'MG': 'Madagaska',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldivi',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Visiwa vya Marshall',
    'MR': 'Mauritania',
    'MU': 'Morisi',
    'MX': 'Meksiko',
    'FM': 'Mikronesia',
    'MD': 'Moldova',
    'MC': 'Monako',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MA': 'Moroko',
    'MZ': 'Msumbiji',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepali',
    'NL': 'Uholanzi',
    'NZ': 'Nyuzilandi',
    'NI': 'Nikaragua',
    'NE': 'Nijeri',
    'NG': 'Nigeria',
    'MK': 'Masedonia ya Kaskazini',
    'NO': 'Norwe',
    'OM': 'Omani',
    'PK': 'Pakistani',
    'PW': 'Palau',
    'PS': 'Palestina',
    'PA': 'Panama',
    'PG': 'Papua Guinea Mpya',
    'PY': 'Paragwai',
    'PE': 'Peru',
    'PH': 'Ufilipino',
    'PL': 'Polandi',
    'PT': 'Ureno',
    'QA': 'Katari',
    'RO': 'Romania',
    'RU': 'Urusi',
    'RW': 'Rwanda',
    'KN': 'Santakitzi na Nevis',
    'LC': 'Santalusia',
    'VC': 'Santavisenti na Grenadini',
    'WS': 'Samoa',
    'SM': 'Samarino',
    'ST': 'Sao Tome na Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegali',
    'RS': 'Serbia',
    'SC': 'Shelisheli',
    'SL': 'Siera Leoni',
    'SG': 'Singapuri',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Visiwa vya Solomon',
    'SO': 'Somalia',
    'ZA': 'Afrika Kusini',
    'SS': 'Sudan Kusini',
    'ES': 'Hispania',
    'LK': 'Sri Lanka',
    'SD': 'Sudani',
    'SR': 'Surinamu',
    'SZ': 'Eswatini',
    'SE': 'Uswidi',
    'CH': 'Uswisi',
    'SY': 'Syria',
    'TJ': 'Tajikistani',
    'TZ': 'Tanzania',
    'TH': 'Tailandi',
    'TL': 'Timor ya Mashariki',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad na Tobago',
    'TN': 'Tunisia',
    'TR': 'Uturuki',
    'TM': 'Turkmenistani',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'Falme za Kiarabu',
    'GB': 'Uingereza',
    'US': 'Marekani',
    'UY': 'Urugwai',
    'UZ': 'Uzbekistani',
    'VU': 'Vanuatu',
    'VA': 'Vatikani',
    'VE': 'Venezuela',
    'VN': 'Vietnamu',
    'YE': 'Yemeni',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
  },
  verification: {
    verifying: 'Inathibitisha barua pepe yako...',
    success: 'Barua pepe Imethibitishwa Kikamilifu!',
    failed: 'Uthibitishaji Umeshindwa',
    accountVerified: 'Akaunti yako imethibitishwa kikamilifu. Sasa unaweza kuingia kwenye akaunti yako.',
    invalidLink: 'Kiungo cha uthibitishaji ni batili au kimeisha muda wake.',
    missingToken: 'Tokeni ya uthibitishaji inakosekana.',
    generalError: 'Hitilafu ilitokea wakati wa uthibitishaji. Tafadhali jaribu tena baadaye.',
    proceedToLogin: 'Endelea kwa Kuingia',
    backToLogin: 'Rudi kwa Kuingia'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Dashibodi',
    system: 'Mfumo',
    settings: 'Mipangilio',
    overview: 'Muhtasari',
    database: 'Hifadhidata',
    logs: 'Kumbukumbu',
    userManagement: 'Usimamizi wa Watumiaji',
    security: 'Usalama',
    systemAdministration: 'Usimamizi wa Mfumo',
    loading: 'Inapakia...',
    close: 'Funga dashibodi',
    edit: 'Hariri',
    systemUptime: 'Muda wa Uendeshaji wa Mfumo',
    avgResponseTime: 'Wastani wa Muda wa Majibu',
    errorRate: 'Kiwango cha Hitilafu',
    activeUsers: 'Watumiaji Hai',
    monthlyActiveUsers: 'Watumiaji Hai wa Kila Mwezi (WAM)',
    fromLastMonth: 'kutoka mwezi uliopita',
    today: 'Leo',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'Afya ya Mfumo',
      hierarchy: 'Uongozi wa Maarifa', // NEW
      documents: 'Usimamizi wa Nyaraka', // NEW
      database: 'Hifadhidata',
      logs: 'Kumbukumbu',
      security: 'Usalama',
      users: 'Watumiaji'
    },
    // --- NEW KEYS ---
    contentManagement: "USIMAMIZI WA MAUDHUI",
    knowledgeHierarchy: "Uongozi wa Maarifa",
    documentManagement: "Usimamizi wa Nyaraka",
    noLogsFound: "Hakuna kumbukumbu zilizopatikana leo",
    invalidLogsResponse: "Muundo batili wa muhtasari wa kumbukumbu",
    logsSummaryError: "Imeshindwa kupakia muhtasari wa kumbukumbu",
    buttons: {
      save: "Hifadhi",
      cancel: "Ghairi",
      switch: "Badilisha Hata Hivyo",
      discard: "Tupa"
    },
    confirm: {
      defaultTitle: "Thibitisha",
      defaultMessage: "Una uhakika?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'Hali ya Afya ya Mfumo',
    runDiagnostics: 'Endesha Uchunguzi',
    resourceUsage: 'Matumizi ya Rasilimali',
    services: {
      apiServices: 'Huduma za API',
      database: 'Hifadhidata',
      cache: 'Akiba',
      storage: 'Hifadhi',
      messageQueue: 'Foleni ya Ujumbe',
      externalApi: 'API ya Nje'
    },
    resources: {
      cpu: 'Matumizi ya CPU',
      memory: 'Matumizi ya Kumbukumbu',
      storage: 'Matumizi ya Hifadhi',
      network: 'Upeo wa Mtandao'
    },
    databaseManagement: 'Usimamizi wa Hifadhidata',
    reindexDatabase: 'Faharisi Hifadhidata',
    lastReindex: 'Faharisi ya Mwisho',
    databaseSize: 'Ukubwa wa Hifadhidata',
    totalTables: 'Jumla ya Jedwali',
    logManagement: 'Usimamizi wa Kumbukumbu',
    rolloverLogs: 'Badilisha Kumbukumbu',
    searchLogs: 'Tafuta Kumbukumbu',
    logTime: 'Wakati',
    logLevel: 'Kiwango',
    logService: 'Huduma',
    logMessage: 'Ujumbe',
    showingEntries: 'Inaonyesha {start}-{end} kati ya {total} viingizo',
    logLevels: {
      error: 'HITILAFU',
      warn: 'ONYO',
      info: 'TAARIFA',
      debug: 'UTATUZI'
    },
    logMessages: {
      connectionTimeout: 'Muda wa kuunganisha umekwisha kwa mtoa huduma wa nje',
      lowDiskSpace: 'Nafasi ya diski chini ya kiwango cha 10%',
      userRoleUpdated: 'Wajibu wa mtumiaji umesasishwa kwa admin@huduma.ai'
    },
    userName: 'Jina',
    userEmail: 'Barua pepe',
    userRole: 'Wajibu',
    userStatus: 'Hali',
    userActions: 'Vitendo',
    roleAdministrator: 'Msimamizi',
    roleUser: 'Mtumiaji',
    statusActive: 'Hai',
    dbActions: {
      reindex: 'Faharisi Upya',
      backup: 'Hifadhi Nakala',
      optimize: 'Boresha',
      reindexDesc: 'Jenga upya faharasa za hifadhidata',
      backupDesc: 'Tengeneza nakala ya hifadhidata',
      optimizeDesc: 'Boresha utendaji wa utafutaji'
    },
    operations: {
      reindexTitle: 'Matokeo ya Kurekebisha Faharasa ya Hifadhidata',
      backupTitle: 'Matokeo ya Nakala Rudufu ya Hifadhidata',
      optimizeTitle: 'Matokeo ya Uboreshaji wa Hifadhidata',
      reindexResults: 'Matokeo ya Faharasa',
      optimizeResults: 'Matokeo ya Uboreshaji',
      collection: 'Mkusanyiko',
      status: 'Hali',
      indexSuggestions: 'Mapendekezo ya Faharasa',
      backupDetails: 'Maelezo ya Nakala Rudufu',
      backupFile: 'Faili la Nakala Rudufu',
      backupLocation: 'Eneo',
      backupSize: 'Ukubwa',
      errorDetails: 'Maelezo ya Hitilafu',
      close: 'Funga',
      resultsTitle: 'Matokeo ya Operesheni',
      reindexDatabase: {
        success: 'Urekebishaji wa faharasa ya hifadhidata umekamilika',
        error: 'Hitilafu wakati wa kurekebishwa faharasa ya hifadhidata',
        loading: 'Inarekebisha faharasa ya hifadhidata...'
      },
      backupDatabase: {
        success: 'Nakala rudufu ya hifadhidata imekamilika',
        error: 'Hitilafu wakati wa kufanya nakala rudufu ya hifadhidata',
        loading: 'Inatengeneza nakala rudufu ya hifadhidata...'
      },
      optimizeDatabase: {
        success: 'Uboreshaji wa hifadhidata umekamilika',
        error: 'Hitilafu wakati wa kuboresha hifadhidata',
        loading: 'Inaboresha hifadhidata...'
      },
      rolloverLogs: {
        success: 'Upitishaji wa kumbukumbu umekamilika',
        loading: 'Inapitisha kumbukumbu...'
      },
      searchLogs: {
        success: 'Utafutaji wa kumbukumbu umekamilika',
        loading: 'Inatafuta kumbukumbu...'
      },
      runDiagnostics: {
        success: 'Uchunguzi umekamilika',
        loading: 'Inafanya uchunguzi...'
      },
      runSecurityScan: {
        success: 'Ukaguzi wa usalama umekamilika',
        loading: 'Inafanya ukaguzi wa usalama...'
      },
      cancel: 'Ghairi',
      save: 'Hifadhi Mabadiliko'
    },
    userManagementSection: {
      totalUsers: 'Jumla ya Watumiaji',
      newUsers: 'Watumiaji Wapya (Mwezi)',
      searchUsers: 'Tafuta watumiaji...',
      clearSearch: 'Futa utafutaji',
      search: 'Tafuta',
      usersFound: 'watumiaji wamepatikana',
      showAllUsers: 'Onyesha Watumiaji Wote',
      searching: 'Inatafuta...',
      searchingUsers: 'Inatafuta watumiaji...',
      noUsersFound: 'Hakuna watumiaji waliopatikana wanaofanana na vigezo vyako vya utafutaji.',
      noUsers: 'Hakuna watumiaji wanapatikana.',
      showing: 'Inaonyesha',
      of: 'kati ya',
      previous: 'Iliyotangulia',
      next: 'Inayofuata',
      searchFields: {
        all: 'Sehemu Zote',
        name: 'Jina',
        email: 'Barua pepe',
        role: 'Wajibu'
      },
      userSearch: {
        resultsFound: 'Imepatikana {total} watumiaji wanaofanana na "{term}"',
        error: 'Hitilafu katika kutafuta watumiaji'
      }
    },
    logsSection: {
      errorLogs: 'Kumbukumbu za Hitilafu',
      warningLogs: 'Kumbukumbu za Tahadhari',
      noErrorLogs: 'Hakuna kumbukumbu za hitilafu zilizorekodiwa leo.',
      noWarningLogs: 'Hakuna kumbukumbu za tahadhari zilizorekodiwa leo.',
      infoLogsNote: 'Kumbukumbu za habari hazionyeshwi kwenye muhtasari. Tumia kazi ya utafutaji kuona aina zote za kumbukumbu.',
      searchResults: 'Matokeo ya Utafutaji ya Hivi Karibuni',
      entriesFound: 'viingizo vimepatikana',
      viewAllResults: 'Ona Matokeo Yote',
      logType: 'Aina',
      logCount: 'Idadi',
      logTypes: {
        connectionTimeout: 'Muda wa muunganisho umekwisha',
        databaseFailed: 'Hoja ya hifadhidata imeshindwa',
        authFailed: 'Uthibitishaji umeshindwa',
        lowDiskSpace: 'Nafasi ya diski chini ya kiwango',
        slowQuery: 'Utendaji wa polepole wa hoja',
        rateLimit: 'Kikomo cha kiwango kinakaribia'
      },
      logSearch: {
        noResultsFound: 'Hakuna kumbukumbu zinazofanana na vigezo vyako vya utafutaji',
        resultsFound: 'Imepatikana {count} viingizo vya kumbukumbu'
      }
    },
    security: {
      title: 'Ufuatiliaji wa Usalama',
      securityScan: 'Ukaguzi wa Usalama',
      runningSecurityScan: 'Uchunguzi Unaendelea...',
      lastSecurityScan: 'Ukaguzi wa Mwisho wa Usalama',
      vulnerabilitiesFound: 'Mapungufu Yaliyopatikana',
      daysAgo: 'siku zilizopita',
      critical: 'hatari',
      medium: 'wastani',
      low: 'ndogo',
      failedLoginAttempts: 'Majaribio ya Kuingia Yaliyoshindwa (24h)',
      suspiciousActivities: 'Shughuli za Kushuku (24h)',
      securityRecommendations: 'Mapendekezo ya Usalama',
      criticalVulnerabilities: 'Udhaifu Mkubwa',
      mediumVulnerabilities: 'Udhaifu wa Wastani',
      lowVulnerabilities: 'Udhaifu Mdogo',
      authenticationIssues: 'Masuala ya Uthibitishaji',
      suspiciousActivityLogs: 'Kumbukumbu za Shughuli za Kushuku',
      securityProbeAttempts: 'Majaribio ya Uchunguzi wa Usalama Yamegunduliwa',
      sensitiveFileAccess: 'majaribio ya kufikia faili nyeti au anwani za mwisho yamegunduliwa',
      envFileAccess: 'Majaribio ya Ufikiaji wa Faili za Mazingira',
      envFileAccessDesc: 'majaribio ya kufikia faili za .env yamegunduliwa',
      gitRepoAccess: 'Majaribio ya Ufikiaji wa Hifadhi ya Git',
      gitRepoAccessDesc: 'majaribio ya kufikia faili za hifadhi ya .git yamegunduliwa',
      recommendedAction: 'Hatua Inayopendekezwa',
      rateLimitRecommendation: 'Fikiria kutekeleza ukomo wa viwango, kuzuia IP kwa wakosaji wa kudumu, na hakikisha uimarishaji sahihi wa seva umewekwa.',
      envFileRecommendation: 'Hakikisha faili za mazingira hazipatikani kutoka kwa saraka za wavuti na usanidi wa seva unazuia ipasavyo ufikiaji wa faili nyeti.',
      gitRepoRecommendation: 'Hakikisha saraka za .git zimelindwa ipasavyo na hazipatikani kutoka kwa wavuti.',
      noVulnerabilitiesFound: 'Hakuna Udhaifu Uliopatikana',
      systemSecure: 'Mfumo wako unaonekana kuwa salama. Endelea kufuatilia mara kwa mara.',
      loadingScan: 'Inapakia matokeo ya ukaguzi...',
      occurrences: 'Matukio',
      firstSeen: 'Ilionekana Kwanza',
      lastSeen: 'Ilionekana Mwisho',
      timestamp: 'Muhuri wa Wakati',
      message: 'Ujumbe',
      service: 'Huduma',
      type: 'Aina',
      severity: 'Ukali',
      url: 'URL',
      matchedTerm: 'Neno Lililolingana',
      lineNumber: 'Nambari ya Mstari',
      lineNumbers: 'Nambari za Mistari',
      showLess: 'Onyesha Kidogo',
      showMore: 'Onyesha Masuala Yote',
      // --- NEW KEY ---
      lastScanJustNow: "Muda mfupi uliopita"
    },
    userEdit: {
      title: 'Hariri Mtumiaji',
      loading: 'Inapakia data ya mtumiaji...',
      userInfo: 'Taarifa za Mtumiaji',
      userId: 'Kitambulisho cha Mtumiaji',
      loginName: 'Jina la Kuingia',
      fullName: 'Jina Kamili',
      dob: 'Tarehe ya Kuzaliwa',
      email: 'Barua Pepe',
      emailVerified: 'Barua Pepe Imethibitishwa',
      verified: 'Imethibitishwa',
      notVerified: 'Haijathibitishwa',
      createdAt: 'Imeundwa',
      lastLogin: 'Kuingia kwa Mwisho',
      never: 'Kamwe',
      accountSettings: 'Mipangilio ya Akaunti',
      accountStatus: 'Hali ya Akaunti',
      accountEnabled: 'Akaunti Imewezeshwa',
      cannotDisableSelf: 'Huwezi kuzima akaunti yako mwenyewe',
      accountRole: 'Jukumu la Akaunti',
      adminRole: 'Jukumu la Msimamizi',
      cannotChangeOwnRole: 'Huwezi kubadilisha jukumu lako mwenyewe',
      adminActions: 'Vitendo vya Msimamizi',
      verifyEmail: 'Thibitisha Barua Pepe',
      resetPassword: 'Tuma Kurekebisha Nenosiri',
      forceLogout: 'Lazimisha Kutoka',
      failedToLoad: 'Imeshindwa kupakia data ya mtumiaji',
      errorLoading: 'Hitilafu katika kupakia data ya mtumiaji',
      saveSuccess: 'Mipangilio ya mtumiaji imesasishwa kwa mafanikio',
      errorSaving: 'Hitilafu katika kuhifadhi mipangilio ya mtumiaji',
      verifyEmailSuccess: 'Barua pepe ya uthibitisho imetumwa kwa mafanikio',
      emailVerificationFailed: 'Imeshindwa kutuma barua pepe ya uthibitisho',
      errorVerifyingEmail: 'Hitilafu katika kutuma barua pepe ya uthibitisho',
      passwordResetSent: 'Barua pepe ya kurekebisha nenosiri imetumwa',
      passwordResetFailed: 'Imeshindwa kutuma barua pepe ya kurekebisha nenosiri',
      errorSendingReset: 'Hitilafu katika kutuma barua pepe ya kurekebisha nenosiri',
      logoutForced: 'Mtumiaji ameondolewa',
      logoutFailed: 'Imeshindwa kumtoa mtumiaji',
      errorForcingLogout: 'Hitilafu katika kutoa mtumiaji kwa lazima',
      // --- NEW KEY ---
      userUpdated: "Mtumiaji amesasishwa kwa mafanikio"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "Usimamizi wa Uongozi wa Maarifa (dondoo: daima kwa Kiingereza - ongeza tafsiri)",
      addCategory: "Ongeza Kitengo Kipya",
      loading: "Inapakia Uongozi...",
      addService: "Ongeza Huduma",
      editCategory: "Hariri Kitengo",
      deleteCategory: "Futa Kitengo",
      editService: "Hariri Huduma",
      deleteService: "Futa Huduma",
      empty: 'Hakuna vitengo vilivyopatikana. Bofya "Ongeza Kitengo Kipya" ili kuanza.',
      formTitleCreateCategory: "Unda Kitengo Kipya",
      formTitleAddService: 'Ongeza Huduma kwa "{categoryName}"',
      formTitleEditCategory: 'Hariri Kitengo: "{itemName}"',
      formTitleEditService: 'Hariri Huduma: "{itemName}"',
      nameEnLabel: "Jina (Kiingereza)",
      translationsTitle: "Tafsiri za Kuonyesha",
      loadingTranslations: "Inapakia tafsiri...",
      selectLang: "Chagua Lugha",
      translationPlaceholder: "Ingiza tafsiri",
      deleteTranslation: "Futa Tafsiri",
      addTranslation: "+ Ongeza Tafsiri",
      saveSuccess: "Kipengee cha uongozi kimehifadhiwa kwa mafanikio.",
      saveError: "Imeshindwa kuhifadhi kipengee cha uongozi.",
      loadError: "Imeshindwa kupakia uongozi wa maarifa.",
      loadTranslationsError: "Imeshindwa kupakia tafsiri.",
      confirmCancelTitle: "Mabadiliko Yasiyohifadhiwa",
      confirmCancelEdit: "Una mabadiliko ambayo hayajahifadhiwa. Una uhakika unataka kughairi?",
      confirmDeleteTitleCategory: "Futa Kitengo?",
      confirmDeleteTitleService: "Futa Huduma?",
      confirmDeleteCategory: 'Una uhakika unataka kufuta Kitengo "{itemName}"? Kitendo hiki hakiwezi kutenduliwa.',
      confirmDeleteService: 'Una uhakika unataka kufuta Huduma "{itemName}"? Kitendo hiki hakiwezi kutenduliwa.',
      deleteSuccessCategory: "Kitengo kimefutwa kwa mafanikio.",
      deleteSuccessService: "Huduma imefutwa kwa mafanikio.",
      deleteErrorCategory: "Imeshindwa kufuta Kitengo.",
      deleteErrorService: "Imeshindwa kufuta Huduma.",
      duplicateLangError: "Lugha zinazojirudia zimepatikana kwenye tafsiri. Tafadhali ziondoe."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "Usimamizi wa Nyaraka",
      addLink: "Ongeza kutoka kwa Kiungo",
      uploadFiles: "Pakia Faili",
      searchPlaceholder: "Tafuta kwa jina la faili...",
      allStatuses: "Hali Zote",
      statusPending: "Inasubiri",
      statusIngested: "Imeingizwa",
      statusRetracted: "Imeondolewa",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "Inachakatwa",
      statusError: "Hitilafu ya Uingizaji",
      statusWarning: "Imeingizwa na Maonyo",
      // ---
      ingestSelected: "Ingiza Zilizochaguliwa",
      colFileName: "Jina la Faili",
      colStatus: "Hali",
      colLabels: "Lebo",
      colUploadDate: "Tarehe ya Kupakia",
      colSize: "Ukubwa",
      loading: "Inapakia nyaraka...",
      empty: "Hakuna nyaraka zilizopatikana.",
      loadError: "Imeshindwa kupakia nyaraka.",
      confirmIngestTitle: "Thibitisha Uingizaji wa Kundi",
      ingest: "Ingiza",
      confirmIngestSelected: "Una uhakika unataka kuingiza faili {count} zilizochaguliwa?",
      ingestQueuedSuccess: "Faili {count} zimewekwa kwenye foleni ya kuingizwa.",
      ingestQueuedError: "Hitilafu imetokea wakati wa mchakato wa uingizaji wa kundi.",
      uploadSuccessMultiple: "Faili {count} zimepakiwa kwa mafanikio.",
      linkSubmitSuccess: 'Imefanikiwa kutambaa na kuhifadhi "{fileName}".',
      actionSuccess: 'Kitendo "{action}" kwenye faili {fileId} kimefanikiwa.',
      metadataUpdateSuccess: 'Metadata ya faili {fileId} imesasishwa.'
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Tengeneza Nenosiri Mpya',
    tokenLabel: 'Tokeni ya Kubadilisha',
    tokenPlaceholder: 'Ingiza tokeni ya kubadilisha',
    validateButton: 'Thibitisha Tokeni',
    newPasswordLabel: 'Nenosiri Mpya',
    newPasswordPlaceholder: 'Tengeneza nenosiri mpya',
    confirmNewPasswordLabel: 'Thibitisha Nenosiri Mpya',
    confirmNewPasswordPlaceholder: 'Thibitisha nenosiri lako mpya',
    resetButton: 'Weka Nenosiri Upya',
    processing: 'Inabadilisha...',
    rememberedPassword: 'Unakumbuka nenosiri lako?',
    backToLogin: 'Rudi Kuingia',
    supportMessage: 'Unahitaji msaada? Wasiliana na timu yetu ya usaidizi',
    passwordRequirements: 'Nenosiri lazima liwe na angalau herufi 8 zenye angalau namba 1, herufi kubwa 1 na herufi maalum 1',
    passwordsDoNotMatch: 'Maneno ya siri hayalingani',
    resetSuccess: 'Nenosiri lako limebadilishwa kwa mafanikio',
    resetFailed: 'Imeshindwa kubadilisha nenosiri. Tafadhali jaribu tena.',
    noTokenProvided: 'Tafadhali utoe tokeni ya kubadilisha',
    expiredToken: 'Tokeni hii ya kubadilisha imekwisha. Tafadhali omba mpya.',
    invalidToken: 'Tokeni batili au isiyojulikana',
    validatingToken: 'Inathibitisha tokeni...',
    redirecting: 'Inaelekeza kwenye ukurasa wa kuingia...',
    passwordStrength: 'Nguvu ya Nenosiri',
    strengthLabels: {
      veryWeak: 'Dhaifu Sana',
      weak: 'Dhaifu',
      fair: 'Wastani',
      good: 'Nzuri',
      strong: 'Imara'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Tumia angalau herufi 8',
      addUppercase: 'Ongeza herufi kubwa',
      addLowercase: 'Ongeza herufi ndogo',
      addNumbers: 'Ongeza nambari',
      addSpecialChars: 'Ongeza herufi maalum'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Weka Nenosiri Upya',
    emailLabel: 'Anwani ya Barua Pepe',
    emailPlaceholder: 'Ingiza barua pepe yako',
    resetButton: 'Tuma Kiunga cha Kubadilisha',
    processing: 'Inatuma...',
    rememberPassword: 'Unakumbuka nenosiri lako?',
    backToLogin: 'Rudi Kuingia',
    supportMessage: 'Unahitaji msaada? Wasiliana na timu yetu ya usaidizi',
    invalidEmail: 'Tafadhali ingiza anwani halali ya barua pepe',
    resetRequestSuccess: 'Kiunga cha kubadilisha nenosiri kimeletwa kwenye barua pepe yako',
    resetRequestFailed: 'Imeshindwa kutuma kiunga cha kubadilisha. Tafadhali jaribu tena.',
    checkEmail: 'Tafadhali angalia barua pepe yako kwa maagizo zaidi.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Tengeneza Akaunti Mpya",
    username: "Jina la mtumiaji",
    usernamePlaceholder: "Ingiza jina la mtumiaji",
    email: "Barua pepe",
    emailPlaceholder: "Ingiza barua pepe yako",
    password: "Nenosiri",
    passwordPlaceholder: "Tengeneza nenosiri",
    confirmPassword: "Thibitisha Nenosiri",
    confirmPasswordPlaceholder: "Thibitisha nenosiri lako",
    acceptTerms: "Ninakubali",
    termsOfService: "Masharti ya Huduma",
    registerButton: "Tengeneza Akaunti",
    processing: "Inachakata...",
    alreadyHaveAccount: "Una akaunti tayari?",
    loginNow: "Ingia",
    privacyNotice: "Kwa kujiandikisha, unakubali Masharti ya Huduma na Sera ya Faragha",
    usernameMinLength: "Jina la mtumiaji lazima liwe na angalau herufi 3",
    invalidEmail: "Tafadhali ingiza anwani halali ya barua pepe",
    passwordRequirements: "Nenosiri lazima liwe na angalau herufi 8 na angalau namba 1 na herufi kubwa 1",
    passwordsDoNotMatch: "Nenosiri hazilingani",
    mustAcceptTerms: "Lazima ukubali Masharti ya Huduma",
    registrationFailed: "Usajili umeshindwa. Tafadhali jaribu tena.",
    usernameExists: "Jina la mtumiaji tayari lipo",
    emailExists: "Barua pepe tayari ipo",
    registrationSuccess: "Usajili Umefanikiwa!",
    verificationEmailSent: "Barua pepe ya uthibitisho imetumwa kwa {email}",
    checkEmailInstructions: "Tafadhali angalia barua pepe yako na fuata maagizo ili kuthibitisha akaunti yako kabla ya kuingia.",
    backToLogin: "Rudi kwa Kuingia",
    noEmailReceived: "Hujapokea barua pepe?",
    resendVerification: "Tuma tena barua pepe ya uthibitisho",
    verificationResent: "Barua pepe ya uthibitisho imetumwa tena",
    verificationResendFailed: "Imeshindwa kutuma tena barua pepe ya uthibitisho. Tafadhali jaribu tena.",
    usernameInvalidChars: 'Jina la mtumiaji linaweza kuwa na herufi, nambari, alama za chini, madoti na hyphen pekee',
    networkError: 'Hitilafu ya mtandao. Tafadhali angalia muunganisho wako na ujaribu tena.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Jina la mtumiaji',
    password: 'Nywila',
    loginButton: 'Ingia',
    or: 'au',
    savedAccounts: 'Akaunti Zilizohifadhiwa',
    loginSuccess: 'Umefanikiwa kuingia',
    loginError: 'Imeshindwa kuingia. Tafadhali angalia taarifa zako.',
    googleLogin: 'Endelea na Google',
    facebookLogin: 'Endelea na Facebook',
    rememberMe: 'Nikumbuke',
    forgotPassword: 'Umesahau nywila?',
    noAccount: 'Huna akaunti?',
    createAccount: 'Fungua akaunti',
    registerNow: "Jiandikishe sasa",
    termsAndPolicy: 'Kwa kuingia, unakubali Masharti yetu ya Huduma na Sera ya Faragha',
    loggingIn: "Inaingia...",
    fieldsRequired: "Jina la mtumiaji na nenosiri zinahitajika",
    invalidCredentials: "Jina la mtumiaji au nenosiri batili",
    tooManyAttempts: "Majaribio mengi ya kuingia. Tafadhali jaribu tena baadaye.",
    loginFailed: "Kuingia kumeshindwa. Tafadhali jaribu tena.",
    oauthNotImplemented: "Kuingia kwa mitandao ya kijamii bado haijatekelezwa",
    savedLoginNotImplemented: "Kuingia kwa akaunti iliyohifadhiwa bado haijatekelezwa"
  },
  charts: {
    tooltip: {
      title: 'Tarehe',
      totalQueries: 'Jumla ya Maswali',
      uniqueUsers: 'Watumiaji wa Kipekee'
    },
    day: 'Siku',
    noData: 'Hakuna Data',
    notAvailable: 'Haipatikani',
    topQueries: 'Maswali ya Juu',
    categoryDistribution: 'Matumizi ya Maeneo ya Maarifa',
    usageTrend: 'Mwelekeo wa Matumizi'
  },
  analytics: {
    title: 'Data za Uchanganuzi & Maoni',
    loading: 'Inapakia data za uchanganuzi...',
    period: 'Kipindi cha Muda',
    charts: {
      satisfactionHeatmap: "Kuridhika kwa Eneo la Maarifa",
      satisfactionSubtitle: "Alama za asilimia kwa wakati"
    },
    timePeriods: {
      week4: "Wiki 4 iliyopita",
      week3: "Wiki 3 iliyopita",
      week2: "Wiki 2 iliyopita",
      week1: "Wiki iliyopita",
      current: "Sasa"
    },
    errors: {
      loading: "Imeshindwa kupakia data ya kuridhika. Tafadhali jaribu tena.",
    },
    status: {
      loading: "Inapakia...",
      noData: "Hakuna data inayopatikana",
      online: "Mfumo Uko Mtandaoni",
      offline: "Mfumo Hauko Mtandaoni",
      responseTime: "Wastani wa Muda wa Kumudu",
      queueLength: "Foleni",
      uptime: "Muda wa Kuendelea",
      error: 'Imeshindwa kupakia data za uchanganuzi'
    },
    periods: {
      daily: 'Kila Siku',
      weekly: 'Kila Wiki',
      monthly: 'Kila Mwezi',
      allTime: 'Wakati Wote'
    },
    metrics: {
      totalQueries: 'Jumla ya Maswali',
      uniqueUsers: 'Watumiaji wa Kipekee',
      avgResponseTime: 'Wastani wa Muda wa Majibu',
      satisfaction: 'Kuridhika kwa Watumiaji'
    },
    table: {
      rank: 'Nafasi',
      query: 'Swali',
      count: 'Idadi',
      avgTime: 'Wastani wa Muda'
    },
    chartLabels: {
      categories: 'Maeneo',
      serviceCategories: 'Maeneo ya Maarifa',
      byUsage: 'kwa Matumizi',
      category: 'Eneo'
    },
    tooltips: {
      selectPeriod: 'Chagua kipindi',
      selectDate: 'Chagua tarehe',
      exportData: 'Toa data'
    },
    gauge: {
      historical: 'Mwenendo wa Kihistoria',
      vsPrevious: 'dhidi ya kipindi cha awali',
      target: 'Lengo'
    },
    ratings: {
      poor: "Dhaifu",
      average: "Wastani",
      good: "Nzuri",
      excellent: "Bora"
    },
    slower: 'polepole zaidi',
    faster: 'haraka zaidi',
    percentage: 'Asilimia',
    note: 'Dashibodi hii inaonyesha takwimu za matumizi na maoni ya watumiaji wa mfumo wa mazungumzo.',
    usageStats: 'Takwimu za Matumizi',
    peakUsers: 'Watumiaji wa Juu Zaidi',
    activeChats: 'Mazungumzo Yanayoendelea',
    usageTrend: 'Mwelekeo wa Matumizi',
    topQueries: 'Maswali ya Juu',
    feedbackSamples: 'Maoni ya Watumiaji',
    close: 'Funga',
    chartComingSoon: 'Uonyeshaji wa chati unakuja hivi karibuni...',
    retry: 'Jaribu tena',
    dailyQueries: 'Maswali ya Kila Siku',
    export: 'Toa Data',
    dateRange: 'Kipindi cha Tarehe',
    startDate: 'Tarehe ya Kuanza',
    endDate: 'Tarehe ya Mwisho',
    rank: 'Nafasi',
    query: 'Ombi',
    count: 'Idadi',
    avgTime: 'Wastani wa Muda',
    serviceUsage: 'Matumizi ya Maeneo ya Maarifa',
    usageTrends: 'Mienendo ya Matumizi',
    week: 'Wiki Iliyopita',
    month: 'Mwezi Uliopita',
    quarter: 'Robo Mwaka Iliyopita',
    year: 'Mwaka Uliopita',
    uniqueUsers: 'Watumiaji wa Kipekee',
    satisfactionRate: 'Kiwango cha Kuridhika',
    satisfactionAnalysis: 'Uchambuzi wa Kuridhika kwa Watumiaji'
  },
  brandName: 'Genie AI: Msaidizi Wako wa Kiserikali wa Kidijitali',
  nav: {
    systemStatus: 'Hali ya Mfumo',
    menu: 'Menyu',
    analytics: 'Takwimu',
    userProfile: 'Profaili',
    settings: 'Mipangilio',
    logout: 'Ondoka',
    profile: 'Profaili Yangu',
    toggleSidebar: 'Geuza upau wa pembeni',
    changeLanguage: 'Badilisha lugha',
    administration: "Utawala",
    languages: {
      english: 'Kiingereza',
      french: 'Kifaransa',
      swahili: 'Kiswahili'
    }
  },
  systemStatus: {
    title: 'Hali ya Huduma',
    services: 'Huduma',
    operational: 'Inafanya Kazi',
    degraded: 'Ina Shida Ndogo',
    outage: 'Haifanyi Kazi',
    allOperational: 'Mifumo Yote',
    someIssues: 'Shida Chache',
    majorIssues: 'Shida Kubwa',
    checking: 'Inakagua...',
    nextDeadline: 'Tarehe ya Mwisho Ijayo',
    days: 'siku',
    viewDetails: 'Angalia Maelezo Zaidi'
  },
  services: {
    eCitizen: 'Tovuti ya eCitizen',
    taxFiling: 'Mfumo wa Kutuma Kodi',
    idApplication: 'Maombi ya Kitambulisho',
    businessReg: 'Usajili wa Biashara',
    drivingLicense: 'Leseni ya Udereva'
  },
  deadlines: {
    taxFiling: 'Tarehe ya Mwisho ya Kutuma Kodi',
    businessRenewal: 'Kuhuisha Leseni ya Biashara',
    idRenewal: 'Kuhuisha Kitambulisho',
    vehicleRegistration: 'Tarehe ya Mwisho ya Usajili wa Gari'
  },
  sidebar: {
    governmentServices: 'Maeneo ya Maarifa',
    chatHistory: 'Historia ya Gumzo',
    searchPlaceholder: 'Tafuta maeneo ya maarifa...',
    createFolder: 'Unda Folda',
    editFolder: 'Hariri Folda',
    folderName: 'Jina la Folda',
    folderNamePlaceholder: 'Ingiza jina la folda',
    moveChat: 'Hamisha Mazungumzo',
    moveChatTo: 'Hamisha Mazungumzo Kwenda',
    selectFolder: 'Chagua Folda',
    deleteChat: 'Futa Mazungumzo',
    deleteChatConfirm: 'Je, una uhakika unataka kufuta mazungumzo haya?',
    deleteChatWarning: 'Kitendo hiki hakiwezi kutenduliwa.',
    renameChat: "Badilisha jina la mazungumzo",
    chatTitle: "Kichwa cha mazungumzo",
    chatTitlePlaceholder: "Ingiza kichwa cha mazungumzo haya",
    deleteFolder: "Futa Folda",
    deleteFolderConfirm: "Una uhakika unataka kufuta folda ya '{name}'?",
    chatsMoveWarning: "Mazungumzo yote katika folda hii yatahamishwa kwenye folda ya chaguo-msingi.",
    weatherTitle: "Utabiri wa Hali ya Hewa",
    weatherLoading: "Inapakia data ya hali ya hewa...",
    weatherError: "Imeshindwa kupakia data ya hali ya hewa. Tafadhali jaribu tena.",
    weatherLocationLoading: 'Inapakia eneo...',
    weatherErrorDefault: 'Haiwezi kupata data ya hali ya hewa.',
    weatherGeolocationUnsupported: 'Geolokeshoni haikubaliwa na kivinjari chako.',
    weatherRefresh: 'Sasisha Hali ya Hewa',
    weatherConditions: {
      clear: 'Wazi',
      partlycloudy: 'Mawingu Kidogo',
      cloudy: 'Mawingu',
      overcast: 'Mawingu Mzito',
      rain: 'Mvua',
      shower: 'Mvua Nyepesi',
      thunderstorm: 'Radi na Mvua',
      snow: 'Theluji'
    },
    title: 'Taarifa na Rasilimali',
    noChats: 'Hakuna mazungumzo ya hivi karibuni',
    relatedDocs: 'Nyaraka Zinazohusiana',
    noDocuments: 'Hakuna nyaraka zinazohusiana',
    faq: 'Maswali Yanayoulizwa Mara kwa Mara',
    tab: {
      all: 'Mazungumzo Yote',
      folders: 'Mafolda',
      starred: 'Yenye Nyota',
      archived: 'Yaliyohifadhiwa'
    },
    savedChats: 'Mazungumzo Yaliyohifadhiwa',
    chats: 'Mazungumzo',
    allChats: "Mazungumzo Yote",
    folders: "Mafolda",
    starredChats: "Yenye Nyota",
    archivedChats: "Yaliyohifadhiwa",
    noFolder: "Hakuna Folda",
    emptyFolder: "Folda hii ni tupu. Hamisha mazungumzo hapa kutoka kwa menyu ya mazungumzo.",
    noStarredChats: "Bado hakuna mazungumzo yaliyowekwa nyota. Weka nyota kwenye mazungumzo ili kuyaongeza hapa.",
    noArchivedChats: "Bado hakuna mazungumzo yaliyohifadhiwa.",
    noSearchResults: 'Hakuna mazungumzo yaliyopatikana kwa "{term}"',
    loadingChats: "Inapakia mazungumzo...",
    errorLoadingConversations: "Imeshindwa kupakia mazungumzo. Tafadhali jaribu tena.",
    errorLoadingUser: "Data ya mtumiaji haijajaa. Tafadhali pakia upya ukurasa.",
    errorNoUser: "Data ya mtumiaji inakosekana. Tafadhali pakia upya ukurasa.",
    retry: "Jaribu tena",
    message: "ujumbe",
    messages: "jumbe",
    created: "Imeundwa",
    updated: "Imesasishwa",
    star: "Weka Nyota",
    unstar: "Ondoa Nyota",
    archive: "Hifadhi",
    chatStarred: "Mazungumzo yamewekwa nyota",
    chatUnstarred: "Mazungumzo yameondolewa nyota",
    chatArchived: "Mazungumzo yamehifadhiwa",
    chatUnarchived: "Mazungumzo yameondolewa kwenye kumbukumbu",
    errorUpdatingChat: "Imeshindwa kusasisha mazungumzo",
    chatRenamed: "Mazungumzo yamebadilishwa jina kwa mafanikio",
    errorRenamingChat: "Imeshindwa kubadilisha jina la mazungumzo",
    chatDeleted: "Mazungumzo yamefutwa kwa mafanikio",
    errorDeletingChat: "Imeshindwa kufuta mazungumzo",
    chatMoved: "Mazungumzo yamehamishwa kwa mafanikio",
    errorMovingChat: "Imeshindwa kuhamisha mazungumzo",
    noPreview: "Hakuna hakikisho linalopatikana",
    searchConversations: 'Tafuta mazungumzo...',
    selectFolderInstruction: "Chagua folda ili kuona mazungumzo yake",
    folderCreated: "Folda imeundwa kwa mafanikio",
    errorCreatingFolder: "Imeshindwa kuunda folda",
    errorLoadingFolders: "Imeshindwa kupakia folda",
    folderUpdated: "Folda imesasishwa kwa mafanikio",
    errorUpdatingFolder: "Imeshindwa kusasisha folda",
    folderDeleted: "Folda imefutwa kwa mafanikio",
    errorDeletingFolder: "Imeshindwa kufuta folda",
    chatRemovedFromFolders: "Mazungumzo yameondolewa kwenye folda",
    errorRemovingChat: "Imeshindwa kuondoa mazungumzo kwenye folda",
    id: "ID",
    labels: "Lebo",
    confidence: "Kujiamini",
    unknown: "Haijulikani"
  },
  leftPanel: {
    cat1: {
      name: '1. Utambulisho & Usajili wa Kiraia',
      children: ['Vyeti vya kuzaliwa', 'Vitambulisho vya Taifa', 'Pasi za kusafiria', 'Vyeti vya ndoa na vifo', 'Usajili wa wapiga kura']
    },
    cat2: {
      name: '2. Huduma za Afya & Ustawi wa Jamii',
      children: ['Upatikanaji wa huduma za afya', 'Mikakati ya chanjo', 'Bima ya afya', 'Huduma za walemavu', 'Msaada wa ustawi na chakula']
    },
    cat3: {
      name: '3. Elimu & Kujifunza',
      children: ['Shule za umma na vyuo vikuu', 'Mikopo na ufadhili wa wanafunzi', 'Programu za elimu ya watu wazima', 'Rasilimali za kujifunza mtandaoni']
    },
    cat4: {
      name: '4. Ajira & Huduma za Kazi',
      children: ['Utafutaji wa kazi na malipo ya ukosefu wa ajira', 'Haki na ulinzi wa wafanyakazi', 'Kanuni za usalama kazini', 'Mafunzo ya stadi na uanagenzi']
    },
    cat5: {
      name: '5. Ushuru & Mapato',
      children: ['Kuwasilisha kodi ya mapato na marejesho', 'Malipo ya kodi ya mali', 'Uzingatiaji kodi za biashara', 'Ushuru wa forodha na uingizaji']
    },
    cat6: {
      name: '6. Usalama wa Umma & Sheria',
      children: ['Polisi na huduma za dharura', 'Mahakama na msaada wa kisheria', 'Kuripoti uhalifu', 'Sheria za ulinzi wa watumiaji']
    },
    cat7: {
      name: '7. Usafiri & Uhamaji',
      children: ['Leseni za udereva na usajili wa magari', 'Usafiri wa umma na miundombinu', 'Makosa ya trafiki na faini', 'Programu za usalama barabarani']
    },
    cat8: {
      name: '8. Makazi & Maendeleo ya Miji',
      children: ['Msaada wa makazi ya umma', 'Usajili wa ardhi na mali', 'Mikopo na ruzuku za makazi', 'Vibali vya ujenzi na upangaji']
    },
    cat9: {
      name: '9. Huduma za Umma & Mazingira',
      children: ['Huduma za maji na umeme', 'Usimamizi wa taka na urejelezaji', 'Kanuni za mazingira', 'Miradi ya nishati mbadala']
    },
    cat10: {
      name: '10. Biashara & Biashara',
      children: ['Usajili wa biashara na leseni', 'Kanuni na vibali vya biashara', 'Misaada na motisha kwa biashara ndogo', 'Msaada wa biashara za mtandaoni']
    },
    cat11: {
      name: '11. Hifadhi ya Jamii & Pensheni',
      children: ['Manufaa ya kustaafu', 'Usimamizi wa mfuko wa pensheni', 'Manufaa ya warithi', 'Pensheni za ulemavu']
    },
    cat12: {
      name: '12. Jamii & Ushiriki wa Kiraia',
      children: ['Kupiga kura na uchaguzi', 'Maoni ya umma na malalamiko ya raia', 'Kujitolea na programu za jamii', 'Ushiriki katika serikali za mitaa']
    }
  },
  settings: {
    title: 'Mipangilio',
    save: 'Hifadhi',
    close: 'Funga',
    saveSettings: 'Hifadhi Mipangilio',
    savingSettings: "Inahifadhi mipangilio yako...",
    settingsSaved: "Mipangilio imehifadhiwa!",
    saveSuccess: 'Mipangilio imehifadhiwa kwa mafanikio',
    saveError: 'Hitilafu katika kuhifadhi mipangilio',
    display: 'Onyesho',
    displayLanguage: 'Lugha ya Onyesho',
    languages: {
      english: 'Kiingereza',
      french: 'Kifaransa',
      swahili: 'Kiswahili'
    },
    theme: 'Mandhari',
    themes: {
      light: 'Mwangaza',
      dark: 'Giza',
      system: 'Mfumo'
    },
    fontSize: 'Ukubwa wa Fonti',
    notifications: 'Arifa',
    emailUpdates: 'Arifa za barua pepe',
    soundNotifications: 'Arifa za sauti',
    accountManagement: 'Usimamizi wa Akaunti',
    emailAddress: 'Anwani ya Barua Pepe',
    emailAddressPlaceholder: 'Anwani yako ya barua pepe',
    password: 'Nenosiri',
    changePassword: 'Badilisha Nenosiri',
    resetUserData: 'Weka Upya Data ya Mtumiaji',
    resetUserDataDesc: 'Hii itafuta data zote za wasifu wako na historia ya mazungumzo.',
    deleteAccount: 'Futa Akaunti',
    deleteAccountDesc: 'Hii itafuta kabisa akaunti yako na data zote zinazohusiana.',
    edit: 'Hariri',
    standardAccount: 'Akaunti ya Kawaida',
    confirmEmailChange: 'Thibitisha Mabadiliko ya Barua Pepe',
    pleaseEnterPassword: 'Tafadhali ingiza nenosiri lako',
    cancel: 'Ghairi',
    account: {
      title: 'Akaunti',
      resetDescription: 'Hii itafuta data zote za wasifu wako na historia ya mazungumzo.',
      confirmReset: 'Je, una uhakika unataka kufuta data zako zote? Hili halitaweza kutendeka tena.',
      resetComplete: 'Data zako zimerudishwa.'
    },
    language: {
      title: 'Lugha',
      selectLabel: 'Lugha ya Onyesho'
    },
    appearance: {
      title: 'Muonekano',
      lightTheme: 'Angavu',
      darkTheme: 'Giza',
      systemTheme: 'Mfumo'
    },
    confirmDeleteAccount: 'Je, una uhakika unataka kufuta akaunti yako? Kitendo hiki hakiwezi kutenduliwa.',
    confirmAccountDeletion: 'Thibitisha Kufuta Akaunti',
    accountDeletionWarning: 'Onyo: Kitendo hiki ni cha kudumu na hakiwezi kutenduliwa. Data zako zote zitafutwa kabisa.',
    deletionReason: 'Sababu ya kufuta (hiari):',
    deletionReasonPlaceholder: 'Nini kilikufanya uamue kufuta akaunti yako?',
    enterPasswordConfirm: 'Ingiza nenosiri lako kuthibitisha:',
    currentPasswordPlaceholder: 'Nenosiri lako la sasa',
    deleting: 'Inafuta...',
    permanentlyDeleteAccount: 'Futa Akaunti',
    accountDeletedSuccess: 'Akaunti yako imefutwa kikamilifu.',
    incorrectPassword: 'Nenosiri lisilo sahihi',
    accountDeletionFailed: 'Imeshindwa kufuta akaunti. Tafadhali jaribu tena baadaye.',
    confirmChange: 'Thibitisha Mabadiliko',
    processing: 'Inachakata...',
    userDataReset: 'Data yako ya wasifu imewekwa upya kwa mafanikio.',
    failedToResetUserData: 'Imeshindwa kuweka upya data yako ya wasifu. Tafadhali jaribu tena.',
    changingEmailTo: 'Kubadilisha barua pepe yako kuwa',
    will: 'kutasababisha',
    logOutSystem: 'Uondolewe kwenye mfumo',
    sendVerificationLink: 'Kutuma kiungo cha uthibitisho kwa barua pepe yako mpya',
    requireVerification: 'Kuhitaji uthibitisho kabla ya kuingia tena',
    checkNewEmailVerification: 'Tafadhali angalia barua pepe yako mpya kwa maagizo ya uthibitisho.',
    unableToVerifyEmail: 'Imeshindwa kuthibitisha barua pepe. Tafadhali jaribu tena.',
    emailAlreadyInUse: 'Barua pepe tayari inatumika',
    enterValidEmail: 'Tafadhali ingiza anwani halali ya barua pepe',
    failedToUpdateEmail: 'Imeshindwa kusasisha barua pepe. Tafadhali jaribu tena.',
    passwordResetInitiated: 'Kiungo cha kuweka upya nenosiri kimetumwa kwa anwani yako ya barua pepe.',
    unableToLoadUser: 'Imeshindwa kupakia taarifa za mtumiaji. Tafadhali jaribu tena.',
    retry: 'Jaribu tena',
    user: 'Mtumiaji',
    loadingUserInfo: 'Inapakia taarifa za mtumiaji...',
    resetUserDataTitle: "Weka Upya Data ya Mtumiaji",
    confirmResetUserData: "Una uhakika unataka kuweka upya data yako yote ya wasifu? Hii itafuta taarifa zako zote za wasifu na historia ya mazungumzo, lakini itaweka stakabadhi zako za akaunti.",
    reset: "Weka Upya",
    deleteAccountTitle: "Futa Akaunti"
  },
  userProfile: {
    title: 'Wasifu wa Mtumiaji',
    privacyInfo: 'Kwa kutoa taarifa zaidi, utapata majibu sahihi na muhimu. Tafadhali soma',
    privacyPolicyLink: 'Sera ya Faragha',
    tabComingSoon: 'Kichupo hiki kipo katika maendeleo na kitapatikana hivi karibuni.',
    saveSuccess: 'Wasifu umehifadhiwa kwa mafanikio',
    loadError: 'Hitilafu katika kupakia data ya wasifu',
    saveError: 'Hitilafu katika kuhifadhi wasifu',
    confirmSaveTitle: "Hifadhi Wasifu",
    confirmSave: "Una uhakika unataka kuhifadhi mabadiliko haya?",
    confirmCancel: 'Una mabadiliko ambayo hayajahifadhiwa. Je, una uhakika unataka kughairi?',
    confirmLeave: 'Je, una uhakika unataka kuondoka? Mabadiliko yoyote ambayo hayajahifadhiwa yatapotea.',
    confirmDiscardChanges: 'Tupa mabadiliko ambayo hayajahifadhiwa?',
    uploadPhoto: 'Pakia Picha',
    uploadFile: 'Pakia Faili',
    photoRequirements: 'Picha lazima iwe wazi, ya hivi karibuni, na ionyeshe uso wako kamili',
    biometricRequirements: 'Ni faili rasmi za data za bayometriki pekee zinazokubaliwa',
    documentUpload: 'Kupakia Nyaraka',
    validationTitle: 'Tafadhali sahihisha makosa yafuatayo:',
    profileIcon: 'Aikoni ya Wasifu',
    change: 'Badilisha',
    chooseProfileIcon: 'Chagua Aikoni ya Wasifu',
    presetIcons: 'Aikoni Zilizowekwa',
    upload: 'Pakia',
    initials: 'Herufi za Kwanza',
    clickToUpload: 'Bofya kupakia',
    useThisImage: 'Tumia Picha Hii',
    useInitials: 'Tumia Herufi za Kwanza',
    tabs: {
      tab1: 'Taarifa za Utambulisho',
      tab2: 'Usajili wa Kiraia & Nyaraka',
      tab3: 'Anwani & Makazi',
      tab4: 'Nyaraka za Kitambulisho & Safari',
      tab5: 'Afya & Rekodi za Matibabu',
      tab6: 'Ajira & Uchumi',
      tab7: 'Elimu & Masomo',
      tab8: 'Fedha & Ushuru',
      tab9: 'Hifadhi ya Jamii & Ustawi',
      tab10: 'Kumbukumbu za Jinai & Sheria',
      tab11: 'Usafiri & Uhamaji',
      tab12: 'Ushiriki wa Kiraia & Kisiasa'
    },
    actions: {
      cancel: 'Ghairi',
      save: 'Hifadhi Profaili',
      previous: 'Iliyopita',
      next: 'Inayofuata',
      saving: 'Inahifadhi...'
    },
    fields: {
      fullName: 'Jina Kamili',
      dob: 'Tarehe ya Kuzaliwa',
      gender: 'Jinsia',
      nationality: 'Uraia',
      maritalStatus: 'Hali ya Ndoa',
      photograph: 'Picha',
      biometric: 'Alama za Vidole / Data za Kibayometriki',
      birthCert: 'Cheti cha Kuzaliwa',
      deathCert: 'Cheti cha Kifo',
      marriageDivorce: 'Rekodi za Ndoa / Talaka',
      adoption: 'Rekodi za Kuasili',
      citizenship: 'Nyaraka za Uraia / Uhamiaji',
      immigration: 'Historia ya Uhamiaji na Visa',
      currentAddress: 'Anwani ya Sasa ya Makazi',
      previousAddresses: 'Anwani za Awali',
      postalCode: 'Nambari ya Posta',
      country: 'Nchi',
      residencyStatus: 'Hali ya Makazi',
      homeOrRental: 'Maelezo ya Umiliki au Upangaji',
      utilityBills: 'Bili za Huduma Zinazohusiana na Anwani',
      landRecords: 'Rekodi za Umiliki wa Ardhi na Mali',
      idCard: 'Nambari ya Kitambulisho cha Taifa',
      passport: 'Maelezo ya Pasipoti',
      driversLicense: 'Leseni ya Udereva',
      voterId: 'Kitambulisho cha Mpiga Kura',
      ssn: 'Nambari ya Hifadhi ya Jamii / Bima ya Taifa',
      militaryRecords: 'Rekodi za Huduma ya Jeshi',
      medicalHistory: 'Historia ya Matibabu na Hali za Afya',
      vaccinations: 'Rekodi za Chanjo',
      insuranceDetails: 'Maelezo ya Bima ya Afya',
      disability: 'Hali ya Ulemavu',
      bloodType: 'Aina ya Damu',
      organDonor: 'Hali ya Mchango wa Viungo',
      prescriptions: 'Maagizo ya Dawa na Matibabu Yaliyopokelewa',
      mentalHealth: 'Historia ya Afya ya Akili',
      eHistory: 'Historia ya Ajira',
      currentEmployer: 'Maelezo ya Mwajiri wa Sasa',
      workPermits: 'Vibali vya Kazi na Mikataba',
      certifications: 'Vyeti na Leseni za Kitaaluma',
      unemployment: 'Hali ya Ukosefu wa Ajira na Manufaa Yaliyopokelewa',
      tin: 'Nambari ya Utambulisho wa Mlipa Kodi (TIN)',
      businessAffiliations: 'Umiliki wa Biashara na Ushirikiano wa Kampuni',
      schools: 'Shule na Vyuo Vilivyohudhiriwa',
      education: 'Elimu',
      degrees: 'Stashahada, Shahada, na Vyeti',
      performance: 'Utendaji wa Kitaaluma na Alama za Mitihani',
      academicRecords: "Rekodi za Kitaaluma",
      scholarships: 'Ufadhili na Msaada wa Kifedha Uliopokelewa',
      incomeTax: 'Rekodi za Kodi ya Mapato',
      bankAccounts: 'Akaunti za Benki na Fedha',
      propertyTax: 'Malipo ya Kodi ya Mali',
      businessTax: 'Maelezo ya Kodi ya Biashara',
      pensionContrib: 'Michango na Uondoaji wa Pensheni',
      loanAid: 'Rekodi za Mikopo na Misaada ya Serikali',
      pensionStatus: 'Hali ya Pensheni na Michango',
      childcare: 'Msaada wa Utunzaji wa Watoto',
      foodAssistance: 'Programu za Msaada wa Chakula / Ustawi',
      housingAssistance: 'Msaada wa Nyumba',
      policeRecords: 'Rekodi za Polisi (historia ya uhalifu, kukamatwa, mashtaka)',
      courtCases: 'Historia ya Kesi za Mahakama',
      finesPenalties: 'Faini na Adhabu',
      paroleProbation: 'Hali ya Parole au Probesheni',
      citizenshipRevocation: 'Kufutwa kwa Uraia (kama inatumika)',
      vehicleReg: 'Maelezo ya Usajili wa Gari',
      trafficViolations: 'Ukiukaji wa Sheria za Trafiki na Faini',
      licenseHistory: 'Historia ya Leseni ya Udereva na Vidokezo',
      publicTransportCard: 'Matumizi ya Kadi ya Usafiri wa Umma',
      voterRegistration: 'Maelezo ya Usajili wa Mpiga Kura',
      electionHistory: 'Historia ya Ushiriki wa Uchaguzi',
      partyMembership: 'Uanachama wa Chama cha Kisiasa',
      militaryStatus: 'Huduma ya Jeshi au Hali ya Utii',
      publicServiceRoles: 'Majukumu ya Huduma za Umma'
    },
    placeholders: {
      fullName: 'Ingiza jina lako kamili la kisheria',
      nationality: 'Ingiza uraia wako',
      searchCountries: 'Tafuta nchi...',
      selectCountry: 'Chagua nchi',
      searchDisciplines: "Tafuta fani...",
      selectDiscipline: "Chagua fani",
      searchDegrees: "Tafuta shahada...",
      selectDegree: "Chagua shahada"
    },
    validation: {
      nameRequired: 'Jina kamili linahitajika',
      dobRequired: 'Tarehe ya kuzaliwa inahitajika',
      dobFuture: 'Tarehe ya kuzaliwa haiwezi kuwa wakati ujao',
      requiredField: '{field} inahitajika',
      invalidFormat: 'Muundo batili wa {field}',
      futureDate: 'Tarehe haiwezi kuwa katika siku zijazo',
      invalidSelection: 'Tafadhali fanya uchaguzi halali',
      passwordLength: 'Nenosiri lazima liwe na angalau herufi 8',
      matchError: 'Sehemu hazilingani'
    },
    errors: {
      savingFailed: 'Imeshindwa kuhifadhi wasifu',
      loadingFailed: 'Imeshindwa kupakia data ya wasifu',
      invalidForm: 'Tafadhali jaza sehemu zote zinazohitajika',
      invalidFileType: 'Aina ya faili batili',
      fileTooLarge: 'Faili ni kubwa sana',
      countryLoadError: 'Hitilafu katika kupakia nchi',
      countryUpdateError: 'Hitilafu katika kusasisha nchi'
    },
    notifications: {
      saveSuccess: 'Wasifu umehifadhiwa kwa mafanikio',
      saveFailed: 'Imeshindwa kuhifadhi wasifu',
      loadSuccess: 'Wasifu umepakiwa kwa mafanikio',
      loadFailed: 'Imeshindwa kupakia wasifu',
      fieldRequired: 'Sehemu hii inahitajika',
      uploadSuccess: 'Faili imepakiwa kwa mafanikio',
      uploadFailed: 'Imeshindwa kupakia faili',
      formChanged: 'Una mabadiliko ambayo hayajahifadhiwa',
      sessionExpired: 'Kipindi chako kimeisha, tafadhali ingia tena',
      profileUpdated: 'Wasifu wako umesasishwa',
      profileIncomplete: 'Wasifu wako haujakamilika'
    },
    instructions: {
      fullNameHelp: 'Ingiza jina lako kamili la kisheria kama linavyoonekana kwenye nyaraka zako rasmi',
      dobHelp: 'Ingiza tarehe yako ya kuzaliwa kwa muundo wa DD/MM/YYYY',
      uploadPhotoHelp: 'Pakia picha ya hivi karibuni. Faili lazima iwe JPG, PNG, au GIF na chini ya 2MB',
      passwordHelp: 'Nenosiri lazima liwe na angalau herufi 8 zenye herufi kubwa moja, namba moja, na herufi maalum moja',
      documentHelp: 'Muundo unaokubaliwa: PDF, JPG, PNG (max 5MB)',
      requiredFields: 'Sehemu zilizowekwa alama ya * zinahitajika',
      selectFromList: 'Tafadhali chagua chaguo kutoka kwa orodha',
      nextTab: 'Endelea kwa sehemu inayofuata',
      previousTab: 'Rudi kwa sehemu iliyotangulia',
      saveInstructions: 'Bofya Hifadhi ili kuhifadhi maelezo yako',
      cancelInstructions: 'Bofya Ghairi ili kutupilia mbali mabadiliko'
    },
    completionStatus: {
      notStarted: 'Haijaanza',
      inProgress: 'Inaendelea',
      complete: 'Imekamilika',
      percentComplete: 'Imekamilika {percent}%',
      tabsCompleted: 'Sehemu {completed} kati ya {total} zimekamilika',
      tabComplete: 'Kichupo kimekamilika!'
    },
    gender: {
      male: 'Mwanaume',
      female: 'Mwanamke',
      other: 'Nyingine',
      preferNot: 'Sipendelei kusema'
    },
    maritalStatus: {
      single: 'Sijaoa/Sijaolewa',
      married: 'Nimeoa/Nimeolewa',
      divorced: 'Nimetalikiwa/Nimetaliki',
      widowed: 'Mjane',
      other: 'Nyingine'
    },
    residencyStatuses: {
      citizen: 'Raia',
      permanentResident: 'Makazi wa Kudumu',
      temporaryResident: 'Makazi ya Muda',
      other: 'Nyingine'
    },
    employmentStatuses: {
      employed: 'Ameajiriwa',
      selfEmployed: 'Ajira Binafsi',
      unemployed: 'Hana Ajira',
      student: 'Mwanafunzi',
      retired: 'Mstaafu',
      homemaker: 'Mama wa Nyumbani',
      other: 'Nyingine'
    },
    educationLevels: {
      primary: 'Elimu ya Msingi',
      secondary: 'Elimu ya Sekondari',
      highSchool: 'Shule ya Sekondari ya Juu',
      vocational: 'Mafunzo ya Ufundi',
      associate: 'Shahada ya Uhusiano',
      bachelor: 'Shahada ya Kwanza',
      master: 'Shahada ya Uzamili',
      doctoral: 'Shahada ya Uzamivu',
      professional: 'Shahada ya Kitaaluma',
      other: 'Nyingine'
    },
    proficiencyLevels: {
      native: 'Lugha ya Asili',
      fluent: 'Anazungumza kwa Ufasaha',
      advanced: 'Ya Juu',
      intermediate: 'Ya Kati',
      basic: 'Msingi'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Haijulikani'
    },
    languages: {
      english: 'Kiingereza',
      french: 'Kifaransa',
      swahili: 'Kiswahili',
      arabic: 'Kiarabu',
      spanish: 'Kihispania',
      portuguese: 'Kireno',
      chinese: 'Kichina',
      japanese: 'Kijapani',
      german: 'Kijerumani',
      russian: 'Kirusi',
      hindi: 'Kihindi',
      urdu: 'Kiurdu',
      other: 'Nyingine'
    },
    yesNo: {
      yes: 'Ndiyo',
      no: 'Hapana'
    },
    select: 'Tafadhali chagua',
    existingFile: 'Faili iliyopo',
    noMatchingCountries: 'Hakuna nchi zinazofanana zilizopatikana',
    noMatchingDisciplines: "Hakuna fani zinazofanana zilizopatikana",
    noMatchingDegrees: "Hakuna shahada zinazofanana zilizopatikana",
    educationOptions: [
      "Uhasibu", "Uhandisi wa Anga", "Sayansi ya Kilimo", "Anthropolojia", "Ujenzi",
      "Historia ya Sanaa", "Akili Bandia", "Astronomia", "Astrofizikia", "Biokemia",
      "Uhandisi wa Biomedikal", "Bioteknolojia", "Utawala wa Biashara", "Uhandisi wa Kemikali",
      "Kemia", "Uhandisi wa Ujenzi", "Mawasiliano", "Uhandisi wa Kompyuta", "Sayansi ya Kompyuta",
      "Usimamizi wa Ujenzi", "Haki za Jinai", "Usalama wa Mtandao", "Sayansi ya Data", "Udaktari wa Meno",
      "Uchumi", "Elimu", "Uhandisi wa Umeme", "Elimu ya Msingi", "Fasihi ya Kiingereza",
      "Uhandisi wa Mazingira", "Sayansi ya Mazingira", "Ubunifu wa Mitindo", "Masomo ya Filamu",
      "Fedha", "Sanaa", "Sayansi ya Chakula", "Sayansi ya Uchunguzi", "Ubunifu wa Michezo", "Jiografia",
      "Jiolojia", "Ubunifu wa Grafiki", "Utawala wa Afya", "Historia", "Usimamizi wa Ukarimu",
      "Rasilimali Watu", "Ubunifu wa Viwanda", "Uhandisi wa Viwanda", "Mifumo ya Habari",
      "Teknolojia ya Habari", "Ubunifu wa Ndani", "Biashara ya Kimataifa", "Mahusiano ya Kimataifa",
      "Uandishi wa Habari", "Sheria", "Sayansi ya Maktaba", "Isimu", "Usimamizi", "Masoko",
      "Sayansi ya Vifaa", "Hisabati", "Uhandisi wa Mitambo", "Masomo ya Vyombo vya Habari", "Tiba",
      "Meteorolojia", "Mikrobaiolojia", "Muziki", "Nanoteknolojia", "Uuguzi", "Lishe",
      "Tiba ya Kazi", "Oseanografia", "Uhandisi wa Mafuta", "Famasia", "Falsafa", "Upigaji Picha",
      "Elimu ya Mazoezi", "Tiba ya Viungo", "Fizikia", "Sayansi ya Siasa", "Saikolojia",
      "Utawala wa Umma", "Afya ya Umma", "Uhusiano wa Umma", "Robotiki", "Elimu ya Sekondari",
      "Kazi ya Jamii", "Sosiolojia", "Uhandisi wa Programu", "Elimu Maalum", "Usimamizi wa Michezo",
      "Takwimu", "Uhandisi wa Mifumo", "Sanaa za Maigizo", "Utalii", "Mipango ya Miji",
      "Udaktari wa Mifugo", "Utengenezaji wa Tovuti", "Biolojia ya Wanyama Pori", "Zoolojia"
    ],
    degreeOptions: [
      "Stashahada ya Uhusiano", "Shahada ya Sanaa (BA)", "Shahada ya Sayansi (BS)", "Shahada ya Uhandisi (BEng)",
      "Shahada ya Utawala wa Biashara (BBA)", "Shahada ya Sanaa Nzuri (BFA)", "Shahada ya Elimu (BEd)",
      "Shahada ya Udaktari (MBBS)", "Shahada ya Sheria (LLB)", "Uzamili wa Sanaa (MA)", "Uzamili wa Sayansi (MS)",
      "Uzamili wa Utawala wa Biashara (MBA)", "Uzamili wa Uhandisi (MEng)", "Uzamili wa Sanaa Nzuri (MFA)",
      "Uzamili wa Elimu (MEd)", "Uzamili wa Sheria (LLM)", "Uzamili wa Afya ya Umma (MPH)",
      "Uzamivu wa Falsafa (PhD)", "Uzamivu wa Udaktari (MD)", "Uzamivu wa Elimu (EdD)",
      "Uzamivu wa Utawala wa Biashara (DBA)", "Uzamivu wa Sheria (JD)", "Diploma ya Kitaaluma",
      "Diploma ya Kiufundi", "Cheti cha Ufundi", "Cheti cha Uzamili", "Diploma ya Baada ya Shahada", "Baada ya Uzamivu"
    ],
    aria: {
      tabList: 'Sehemu za fomu ya wasifu',
      nextButton: 'Nenda kwenye sehemu inayofuata',
      prevButton: 'Nenda kwenye sehemu iliyotangulia',
      closeButton: 'Funga fomu ya wasifu',
      saveButton: 'Hifadhi data ya wasifu',
      requiredField: 'Sehemu inayohitajika',
      dropdownSelect: 'Chagua chaguo'
    }
  },
  chatbot: {
    placeholder: 'Andika swali lako hapa...',
    sendButton: 'Tuma',
    fileReceived: 'Faili imepokelewa.',
    fileUploadError: 'Hitilafu katika kupakia faili.',
    processingError: 'Hitilafu katika kushughulikia ombi lako.',
    timeoutError: 'Seva inachukua muda mrefu zaidi ya kawaida. Tafadhali jaribu tena baada ya muda mfupi.',
    welcomeMessage: 'Welcome to UPB! How can I assist you with university services today?',
    attachFile: 'Ambatisha Faili',
    fileTooLarge: 'Faili ni kubwa sana. Ukubwa wa juu ni {maxSize}.',
    saveChat: 'Hifadhi Mazungumzo',
    chatSaved: 'Mazungumzo Yamehifadhiwa',
    chatTitle: 'Kichwa cha Mazungumzo',
    chatTitlePlaceholder: 'Ingiza kichwa cha mazungumzo haya',
    selectFolder: 'Chagua Folda',
    newChat: 'Mazungumzo Mapya',
    clearContext: 'Futa muktadha na anza mazungumzo mapya',
    unsavedChanges: 'Una mabadiliko ambayo hayajahifadhiwa. Una uhakika unataka kuanza mazungumzo mapya?',
    whatCanIHelp: "Naweza kukusaidia vipi leo?",
    justChat: "Ongea tu",
    queryContext: "Muktadha wa Hoja",
    contextAdded: 'Muktadha umeongezwa kwenye swali lako',
    contextRemoved: 'Muktadha umeondolewa kutoka kwenye swali lako',
    sessionUpdated: 'Kikao kimesasishwa',
    newChatStarted: 'Mazungumzo mapya yameanzishwa',
    loadError: 'Imeshindwa kupakia historia ya mazungumzo',
    responsePrefix: "Nimepokea ujumbe wako",
    withContext: "na muktadha",
    conversationLoaded: "Mazungumzo yamepakiwa kwa mafanikio!",
    saveConfirmTitle: "Hifadhi Mazungumzo Yaliyopo",
    saveConfirmMessage: "Hifadhi mazungumzo yaliyopo?",
    loadConfirmTitle: "Pakia Mazungumzo Yaliyopo",
    loadConfirmMessage: "Una mabadiliko ambayo hayajahifadhiwa. Je, unataka kuyatupa na kupakia mazungumzo yaliyochaguliwa, au kuhifadhi mazungumzo ya sasa kwanza?",
    loadAndDiscard: "Pakia na Tupa",
    saveAndLoad: "Hifadhi na Pakia",
    saveAndStartNew: "Hifadhi na Anza Mazungumzo Mapya",
    discardAndStartNew: "Tupa na Anza Mazungumzo Mapya",
    newChatTitle: "Anza Mazungumzo Mapya",
    exportChat: 'Hamisha Mazungumzo',
    exportFilename: 'Jina la Faili',
    exportFilenamePlaceholder: 'Ingiza jina la faili',
    exportButton: 'Hamisha',
    exportSuccess: 'Mazungumzo yamehamishwa kwa mafanikio',
    exportError: 'Imeshindwa kuhamisha mazungumzo. Tafadhali jaribu tena.'
  },
  quickhelp: {
    applyForID: "Omba kitambulisho",
    payTaxes: "Lipa kodi",
    startBusiness: "Anza biashara",
    findHealthcare: "Pata huduma za afya",
    educationServices: "Huduma za elimu",
    transportLicenses: "Usafiri na leseni",
    housingPrograms: "Programu za nyumba",
    findJobs: "Tafuta kazi",
    justChat: "Ongea tu",
    justChatPrompt: "Ningependa kuzungumza kuhusu huduma za serikali",
    applyForIDPrompt: "Ninahitaji maelezo kuhusu jinsi ya kuomba kitambulisho cha kitaifa",
    payTaxesPrompt: "Je, ni mchakato gani wa kulipa kodi zangu mtandaoni?",
    startBusinessPrompt: "Niongoze kupitia hatua za kusajili biashara mpya",
    findHealthcarePrompt: "Wapi ninaweza kupata maelezo kuhusu huduma za afya ya umma?",
    educationServicesPrompt: "What academic services are available for students at UPB?",
    transportLicensesPrompt: "Je, ninawezaje kuhuisha leseni yangu ya udereva?",
    housingProgramsPrompt: "Tell me about student housing options and residence halls at UPB",
    findJobsPrompt: "Ni fursa zipi za kazi za serikali zinazopatikana kwa sasa?"
  },
  common: {
    cancel: 'Ghairi',
    create: 'Unda',
    save: 'Hifadhi',
    move: 'Hamisha',
    delete: 'Futa',
    // --- NEW KEYS ADDED ---
    ok: 'SAWA',
    ingest: 'Chakata',
    retract: 'Ondoa',
    loading: 'Inapakia...',
    refresh: 'Onyesha Upya'
  },
  feedback: {
    title: 'Maoni',
    button: 'Maoni',
    positive: 'Maoni mazuri',
    negative: 'Maoni hasi',
    promptText: 'Je, jibu hili lilikuwa la msaada?',
    placeholder: 'Maoni ya ziada...',
    submit: 'Wasilisha Maoni',
    close: 'Ghairi',
    thankYouMessage: 'Asante kwa maoni yako!',
    submitting: 'Inawasilisha...',
    error: 'Imeshindwa kuwasilisha maoni. Tafadhali jaribu tena.',
    success: 'Asante kwa maoni yako!',
  },
  responseRating: {
    title: 'Tusaidie Kuboresha',
    note: 'Maoni yako yatatumika kuboresha chatbot na kuboresha majibu kwa muda.',
    chatbotResponse: 'Jibu la Chatbot:',
    ratingLabels: {
      1: 'Haina msaada',
      2: 'Msaada Kidogo',
      3: 'Msaada wa Wastani',
      44: 'Msaada Sana',
      5: 'Inabadilisha Maisha'
    },
    additionalComments: 'Maoni ya ziada...',
    submit: 'Wasilisha',
    cancel: 'Ghairi'
  },
  upload: {
    alt: 'Pakia'
  },
  details: {
    loading: 'Inapakia Maelezo ya Faili...',
    title: 'Maelezo ya Faili',
    close: 'Funga',
    fileName: 'Jina la Faili',
    author: 'Mwandishi',
    labels: 'Lebo',
    selectAll: 'Chagua Zote',
    loadingLabels: 'Inapakia lebo...',
    status: 'Hali',
    fileId: 'Kitambulisho cha Faili',
    fileType: 'Aina ya Faili',
    viewFile: 'Tazama Faili',
    visitLink: 'Tembelea Kiungo cha Nje',
    openFile: 'Fungua faili kwenye kichupo kipya',
    fileSize: 'Ukubwa wa Faili',
    uploadDate: 'Tarehe ya Kupakia',
    hash: 'Hashi ya SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "Maelezo",
      ingestionLog: "Kumbukumbu ya Uchakataji"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Vitendo vya Kusitisha:",
      killDocument: "Sitisha Hati Hii",
      killProcess: "Sitisha Mchakato wa Uchakataji",
      timestamp: "Mhuri wa Wakati",
      level: "Kiwango",
      stage: "Hatua",
      message: "Ujumbe",
      loadingLogs: "Inapakia kumbukumbu...",
      noLogs: "Hakuna kumbukumbu zilizopatikana."
    },
    buttons: {
      saveMetadata: 'Hifadhi Metadata',
      retract: 'Ondoa',
      ingest: 'Chakata'
    },
    notifications: {
      loadError: 'Imeshindwa kupakia maelezo ya faili.',
      validationError: 'Jina la Faili na Mwandishi yanahitajika.',
      saveSuccess: 'Metadata imesasishwa kikamilifu.',
      saveError: 'Imeshindwa kuhifadhi metadata.',
      tokenError: 'Tokeni ya uthibitishaji haipatikani kwenye data ya mtumiaji.',
      viewError: 'Haikuweza kupakia faili kwa kutazamwa.',
      ingestSuccess: 'Faili imewekwa kwenye foleni ya kuchakatwa kikamilifu.',
      ingestError: 'Imeshindwa kuanzisha mchakato wa uchakataji.',
      retractSuccess: 'Faili imeondolewa kikamilifu.',
      retractError: 'Imeshindwa kuondoa faili.',
      deleteSuccess: 'Faili imefutwa kikamilifu.',
      deleteError: 'Imeshindwa kufuta faili.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Tafadhali chagua angalau lebo moja kabla ya kuchakata.",
      ingestSaving: "Inahifadhi metadata kabla ya uchakataji...",
      ingestSaveFailed: "Imeshindwa kuhifadhi metadata. Uchakataji umesitishwa.",
      logError: "Imeshindwa kupata kumbukumbu za uchakataji.",
      killDocSent: "Ombi la kusitisha hati hii limetumwa.",
      killProcSent: "Ombi la kusitisha mchakato wa uchakataji limetumwa."
    },
    confirm: {
      ingest: 'Una uhakika unataka kuchakata faili hii? Hii itaanza mchakato wa data.',
      retract: 'Una uhakika unataka kuondoa faili hii?',
      delete: 'Una uhakika unataka kufuta faili hii kabisa? Kitendo hiki hakiwezi kutenduliwa.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Thibitisha Uchakataji",
      retractTitle: "Thibitisha Kuondoa",
      deleteTitle: "Thibitisha Kufuta",
      killDocTitle: "Sitisha Uchakataji wa Hati",
      killDoc: "Una uhakika unataka kusitisha kazi ya uchakataji kwa HATI HII? Mfumo utajaribu kurudisha nyuma kwa usalama.",
      killProcTitle: "Sitisha MCHAKATO MZIMA wa Uchakataji",
      killProc: "ONYO: Hii itasitisha huduma nzima ya uchakataji ya backend, ikiathiri FAILI ZOTE zinazochakatwa kwa sasa. Una uhakika kabisa?"
    }
  },
  uploadDialog: {
    title: 'Pakia Faili',
    dropzone: 'Buruta na udondoshe faili hapa, au bofya kuchagua',
    allowedTypesLabel: 'Aina zinazoruhusiwa:',
    buttonUpload: 'Pakia Faili {count}', // Adjust for Swahili plural rules if needed
    remove: 'Ondoa',
    uploading: 'Inapakia...',
    notifications: {
      dropError: 'Faili pekee ndizo zinaweza kudondoshwa. Tafadhali hakikisha unaburuta faili halali kutoka kwa kompyuta yako.',
      typeNotAllowed: 'Aina ya faili "{extension}" hairuhusiwi.',
      shortcutUnsupported: 'Faili za njia za mkato (.url) hazitumiki. Tafadhali buruta faili halisi.',
      duplicate: 'Faili "{fileName}" tayari imeongezwa.',
      uploadSuccess: 'Imefanikiwa kupakia {fileName}',
      uploadFailed: 'Imeshindwa kupakia {fileName}.'
    }
  }
}